import { IResponse } from "models";

export enum ActionType {
  GET_DETAIL_SYMTOM_CHART = "action/GET_DETAIL_SYMTOM_CHART",
  GET_DETAIL_SYMTOM_CHART_SUCCESS = "action/GET_DETAIL_SYMTOM_CHART_SUCCESS",
  GET_DETAIL_SYMTOM_CHART_ERROR = "action/GET_DETAIL_SYMTOM_CHART_ERROR",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface DetailSymtomPayload {
  aggregate_date_to: string;
}

export interface DetailSymtomResponse extends IResponse {
  amount: any;
}
